module.exports = __webpack_public_path__ + "static/media/mode-de-paiement.aa63182f.png";